import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box, Link, Text, Button, Flex, Heading } from '@chakra-ui/react';
import Layout from '../components/Layout';
import HeroImage from '../images/bg-diagonal.webp';
import BackgroundImage from '../components/shared/BackgroundImage';
import DirectOrderingGif from '../images/direct-ordering.gif';
import { URLS } from '../v2/constants';

const CtaButton = () => (
  <Link href={URLS.directOrdering.scheduleMeeting} color="white">
    <Button size="lg" minW="64">
      Schedule a Meeting
    </Button>
  </Link>
);

const DirectOrdering = () => (
  <Layout noIndex isNavInitiallyWhite>
    <BackgroundImage imageUrl={HeroImage}>
      <Flex
        w="100%"
        minH="800px"
        h="fit-content"
        px={['4', '16']}
        pb={['6']}
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <Box maxW="4xl" color="white">
          <Heading
            as="h1"
            color="white"
            mb="10"
            fontWeight={700}
            fontSize={['3xl', '4xl', '4xl', '5xl']}
            lineHeight={['150%', '120%']}
            zIndex="10"
          >
            Now you can place your material orders in HOVER
          </Heading>

          <Box maxW="2xl" mx="auto">
            <Text color="white" fontSize="2xl" mb="7">
              <b>Introducing: Direct Ordering.</b>
              <br />
              <br />
              Start placing dependable orders in minutes, not hours. Talk to us
              to see how and learn about current promotions.
            </Text>

            <CtaButton />
          </Box>
        </Box>
      </Flex>
    </BackgroundImage>
    <Box py={[20]} maxW="6xl" mx="auto">
      <Box maxW="4xl" mx="auto" px="5">
        <Heading fontSize="3xl" textAlign="center">
          Integrated with Top Roofing Suppliers
        </Heading>

        <StaticImage src="../images/partner-lockups.webp" alt="Partner logos" />
        <br />
        <Text fontSize="2xl" textAlign="center">
          From measuring to ordering, you can now do everything in one place
          with HOVER. Powered by to-the-inch accurate measurements, material
          orders are populated with quantities, SKUs, and live pricing based on
          how you buy and install, so you can place dependable roofing orders
          instantly.
        </Text>
      </Box>
      <br />
      <br />
      <Box maxW="4xl" mx="auto" px="5">
        <img
          style={{ margin: 'auto', borderRadius: 10 }}
          src={DirectOrderingGif}
          alt="Animation of HOVER's direct ordering workflow"
        />
        <br />
        <br />
      </Box>
      <Box maxW="2xl" mx="auto" px="5" pt="10">
        <Text fontSize="2xl" textAlign="center">
          Click below to get a demo and learn about current promotions.
        </Text>
        <Box pt="20" textAlign="center">
          <CtaButton />
        </Box>
      </Box>
    </Box>
  </Layout>
);

export default DirectOrdering;
